import {
    HttpContextToken,
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../service';
import { ToastService } from '@services/common/toast.service';
import { Injectable, Injector } from '@angular/core';
import { AppRoutingService } from '@services/app-routing/app-routing.service';

export const BYPASS_ERROR = new HttpContextToken(() => false);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    /**
     * @param {AuthenticationService} authenticationService
     * @param {Router} router
     * @param {ToastService} toastService
     */
    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private injector: Injector,
        private appRouting: AppRoutingService,
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const toastService = this.injector.get(ToastService);

        return next.handle(request).pipe(
            catchError((err: HttpErrorResponse) => {
                if (request.context.get(BYPASS_ERROR)) throw new Error('errorMessage');
                if (err) {
                    let errorMessage = '';
                    switch (err.status) {
                        case 400:
                            // Display generic error
                            this.router.navigate(['/pages/error']);
                            break;
                        case 401:
                            if (
                                err.error?.includes("Unauthorized: The organization's license is invalid or expired.")
                            ) {
                                // Redirect to login with custom parameters
                                this.authenticationService.logout(false).subscribe(() => {
                                    this.router.navigate(['/auth/login'], { queryParams: { licenseExpired: true } });
                                });
                            } else {
                                // Redirect to login
                                this.authenticationService.logout(true).subscribe();
                            }
                            break;
                        case 403:
                            // Display ForbiddenComponent
                            this.router.navigate(['/pages/access-denied']);
                            break;
                        case 404:
                            // Display NotFoundComponent
                            this.router.navigate(['/pages/not-found']);
                            break;
                        case 409:
                            //If error contains translationKey, show error message with translation key else redirect to error page
                            err.error.translationKey
                                ? toastService.showError(
                                      { details: `errors.backend.${err.error.translationKey}` },
                                      true,
                                  )
                                : this.router.navigate(['/pages/error']);

                            break;
                        case 422:
                            this.authenticationService.logout().subscribe();
                            break;
                        default:
                            //if the status error is 500 or higher keep the same structure but always redirect to login page
                            if (err.status >= 500) {
                                const translationKey = err.error.translationKey
                                    ? `errors.backend.${err.error.translationKey}`
                                    : 'errors.500';
                                toastService.showError({ details: translationKey }, true);
                            } else toastService.showError({ details: 'errors.general' }, true);
                    }
                }
                throw new Error('errorMessage');
            }),
        );
    }
}
